
(function () {
  'use strict';
  function initializeColorGuideCart() {
    var root = document.querySelector('.tcg-site');
    if (!root || root.dataset.cartDrawerInitialized === 'true') return;
    var dialog = root.querySelector('#tcg-cart-dialog');
    var contents = root.querySelector('#tcg-cart-contents');
    var message = root.querySelector('#tcg-cart-message');
    var bottom = root.querySelector('#tcg-cart-bottom');
    var subtotal = root.querySelector('#tcg-cart-subtotal-value');
    if (!dialog || !contents || !message || !bottom || !subtotal) return;
    root.dataset.cartDrawerInitialized = 'true';
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (routeRoot.charAt(routeRoot.length - 1) !== '/') routeRoot += '/';
    var currency = root.getAttribute('data-tcg-cart-currency') || 'USD';
    var currentCart = null;
    var featuredVariantId = Number(root.getAttribute('data-tcg-sale-variant-id') || 0);
    var featuredCompareAtCents = Number(root.getAttribute('data-tcg-sale-compare-at') || 0);
    var lastFocused = null;
    var busy = false;

    function formatMoney(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency }).format(amount);
      } catch (e) {
        return '$' + amount.toFixed(2);
      }
    }
    function element(tag, className, text) {
      var e = document.createElement(tag);
      if (className) e.className = className;
      if (text !== undefined) e.textContent = String(text);
      return e;
    }
    function showMessage(text) {
      message.textContent = text || '';
      message.hidden = !text;
    }
    async function requestJSON(path, options) {
      var response = await fetch(routeRoot + path, Object.assign({credentials:'same-origin',headers:{'Accept':'application/json'}}, options || {}));
      var data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update the cart.');
      return data;
    }
    function cartButton(tag, text, line, quantity, className, ariaLabel) {
      var button = element(tag, className, text);
      button.type = 'button';
      button.dataset.tcgLine = String(line);
      button.dataset.tcgQuantity = String(quantity);
      if (ariaLabel) button.setAttribute('aria-label', ariaLabel);
      return button;
    }
    function render(cart) {
      currentCart = cart;
      if (cart.currency) currency = cart.currency;
      contents.replaceChildren();
      contents.setAttribute('aria-busy', 'false');
      root.querySelectorAll('[data-tcg-cart-count]').forEach(function (node) {
        node.textContent = String(cart.item_count);
        node.hidden = cart.item_count === 0;
      });
      root.querySelectorAll('[data-tcg-cart-heading-count]').forEach(function(node) {
        node.textContent = '(' + cart.item_count + ')';
      });
      if (!cart.items || cart.items.length === 0) {
        var empty = element('div', 'tcg-cart-empty');
        empty.appendChild(element('span', 'tcg-cart-empty-icon', '✳'));
        empty.appendChild(element('h3', null, 'Your cart is empty'));
        empty.appendChild(element('p', null, 'A thoughtful gift starts with noticing.'));
        var returnButton = element('button', null, 'Continue exploring');
        returnButton.type = 'button';
        returnButton.dataset.tcgCartClose = '';
        empty.appendChild(returnButton);
        contents.appendChild(empty);
        bottom.hidden = true;
        return;
      }
      cart.items.forEach(function (item, index) {
        var line = element('article', 'tcg-cart-line');
        if (item.image) {
          var img = element('img', 'tcg-cart-line-img');
          img.src = item.image;
          img.alt = item.product_title || 'Product';
          img.width = 88;
          img.height = 114;
          img.loading = 'lazy';
          line.appendChild(img);
        } else {
          line.appendChild(element('div', 'tcg-cart-line-img'));
        }
        var meta = element('div', 'tcg-cart-line-main');
        var title = element('a', 'tcg-cart-line-title', item.product_title || 'Product');
        title.href = item.url || '/';
        meta.appendChild(title);
        meta.appendChild(element('p', 'tcg-cart-line-desc', 'Digital PDF guide'));
        var priceRow = element('div', 'tcg-cart-line-pricing');
        priceRow.appendChild(element('div', 'tcg-cart-line-price', formatMoney(item.final_line_price)));
        if (Number(item.variant_id) === featuredVariantId && featuredCompareAtCents > 0) {
          var compareTotal = featuredCompareAtCents * Number(item.quantity);
          if (compareTotal > Number(item.final_line_price)) {
            var original = element('del', 'tcg-cart-line-compare', formatMoney(compareTotal));
            original.setAttribute('aria-label', 'Compare-at price');
            priceRow.appendChild(original);
            priceRow.appendChild(element('small', 'tcg-cart-line-saving', 'Save ' + formatMoney(compareTotal - Number(item.final_line_price))));
          }
        }
        meta.appendChild(priceRow);
        var controls = element('div', 'tcg-cart-line-controls');
        var qty = element('div', 'tcg-cart-quantity');
        qty.setAttribute('aria-label', 'Quantity');
        qty.appendChild(cartButton('button', '−', index+1, Math.max(0,item.quantity-1), null, 'Decrease quantity'));
        var output = element('output', null, item.quantity);
        output.setAttribute('aria-label', 'Current quantity');
        qty.appendChild(output);
        qty.appendChild(cartButton('button', '+', index+1, item.quantity+1, null, 'Increase quantity'));
        controls.appendChild(qty);
        controls.appendChild(cartButton('button', 'Remove', index+1, 0, 'tcg-cart-remove', 'Remove ' + (item.product_title || 'product')));
        meta.appendChild(controls);
        line.appendChild(meta);
        contents.appendChild(line);
      });
      subtotal.textContent = formatMoney(cart.total_price);
      bottom.hidden = false;
    }
    async function refreshCart() {
      var cart = await requestJSON('cart.js');
      render(cart);
      return cart;
    }
    function openDrawer() {
      lastFocused = document.activeElement;
      if (!dialog.open) {
        dialog.showModal();
      }
      showMessage('');
      contents.setAttribute('aria-busy','true');
      refreshCart().catch(function(error) {
        contents.setAttribute('aria-busy','false');
        showMessage(error.message);
      });
    }
    function closeDrawer() {
      if (dialog.open) dialog.close();
    }
    dialog.addEventListener('close', function () {
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    });
    dialog.addEventListener('click', function(event) {
      if (event.target === dialog) closeDrawer();
    });
    root.addEventListener('click', async function(event) {
      var opener = event.target.closest('[data-tcg-cart-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }
      var closer = event.target.closest('[data-tcg-cart-close]');
      if (closer) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      var changer = event.target.closest('[data-tcg-line]');
      if (!changer || busy) return;
      busy = true;
      showMessage('');
      changer.disabled = true;
      contents.setAttribute('aria-busy','true');
      try {
        var updated = await requestJSON('cart/change.js',{
          method:'POST',
          headers:{'Accept':'application/json','Content-Type':'application/json'},
          body:JSON.stringify({line:Number(changer.dataset.tcgLine),quantity:Number(changer.dataset.tcgQuantity)})
        });
        render(updated);
      } catch(error) {
        showMessage(error.message);
        try { await refreshCart(); } catch(ignore) { contents.setAttribute('aria-busy','false'); }
      } finally {
        busy = false;
      }
    });
    root.addEventListener('submit', async function(event) {
      var form = event.target.closest('.tcg-product-form');
      if (!form) return;
      event.preventDefault();
      if (busy) return;
      busy = true;
      var submit = form.querySelector('[name="add"]');
      if (submit) submit.disabled = true;
      var errorNode = form.querySelector('.tcg-product-form-error');
      if (!errorNode) {
        errorNode = element('p','tcg-product-form-error');
        errorNode.setAttribute('role','alert');
        form.appendChild(errorNode);
      }
      errorNode.textContent = '';
      var idField = form.querySelector('[name="id"]');
      try {
        if (!idField || !idField.value) throw new Error('This item is currently unavailable.');
        await requestJSON('cart/add.js',{
          method:'POST',
          headers:{'Accept':'application/json','Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:Number(idField.value),quantity:1}]})
        });
        openDrawer();
      } catch(error) {
        errorNode.textContent = error.message;
      } finally {
        busy = false;
        if (submit) submit.disabled = false;
      }
    });
    refreshCart().catch(function(){ contents.setAttribute('aria-busy','false'); });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeColorGuideCart);
  else initializeColorGuideCart();
})();
